import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  Title,
  Tooltip,
  ChartData,
  ChartOptions,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import the plugin
import './styles/DashCharts.scss';

ChartJS.register(ArcElement, CategoryScale, Legend, Title, Tooltip, ChartDataLabels); // Register Data Labels

interface DashPieChartProps {
  data: any;
  title: string;
}

const DashPieChart: React.FC<DashPieChartProps> = (props) => {

  const formatNumber = (value: number): string => {
    if (isNaN(value)) return String(value); // If not a number, return as is

    if (value >= 1_000_000) {
      return `${(value / 1_000_000).toFixed(2)} M`; // Convert to millions with 2 decimal places
    }
    else if (value >= 1_000) {
      return `${(value / 1_000).toFixed(0)}K`; // Convert to thousands with 2 decimal places
    }
    return value.toLocaleString(); // Add commas (e.g., 10,000)
  };

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        display: true,
        labels: {
          boxWidth: 12,
          padding: 10,
          font: {
            size: 11,
          },
        },
      },

      title: {
        display: true,
        text: props.title,
        font: {
          size: 14,
        },
        padding: {
          top: 5,
          bottom: 5,
        },
      },

      // 🔹 **Data Labels Plugin (Always Show Values)**
      datalabels: {
        color: 'black', // Label color
        anchor: 'center', // Position inside the pie chart
        align: 'center',
        formatter: (value, ctx) => {
          let label = ctx.chart.data.labels?.[ctx.dataIndex] || '';
          return `${formatNumber(value)}`; // Format numbers
        },
        font: {
          size: 14,
          weight: 'bold',
        },
      },
    },
    layout: {
      padding: 2,
    },
  };

  if (!props.data) return null;

  return (
    <>
      {props.data?.datasets?.length > 0 && (<Doughnut data={props.data} options={options} plugins={[ChartDataLabels]} />)}
    </>
  );
};

export default DashPieChart;